// Confirm dialog for the "you're about to take someone else's
// Commitment private" path. Surfaces the assignee that will be
// displaced so users see what they're doing before the PATCH fires.

import { Modal } from "@/design-system";


export interface PrivateVisibilityConfirmModalProps {
  open: boolean;
  /** Display name (or email / placeholder) for the user the
   * Commitment is currently assigned to — used inline in the body
   * copy so the warning is concrete. */
  currentAssigneeName: string;
  isPending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}


export function PrivateVisibilityConfirmModal({
  open, currentAssigneeName, isPending = false, onCancel, onConfirm,
}: PrivateVisibilityConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title="Make this Commitment private?"
      size="sm"
      footer={
        <>
          <button
            type="button"
            data-testid="commitment-private-confirm-cancel"
            onClick={onCancel}
            className="rounded-md border border-border-subtle px-3 py-1.5 text-sm text-text-primary hover:bg-recessed"
          >
            Cancel
          </button>
          <button
            type="button"
            data-testid="commitment-private-confirm-submit"
            onClick={onConfirm}
            disabled={isPending}
            className="rounded-md bg-teal px-3 py-1.5 text-sm font-medium text-text-inverse hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isPending ? "Saving…" : "Make private and assign to me"}
          </button>
        </>
      }
    >
      <div
        data-testid="commitment-private-confirm-modal"
        className="text-sm text-text-secondary"
      >
        Private Commitments can only be assigned to you. This Commitment
        is currently assigned to{" "}
        <span className="font-medium text-text-primary">
          {currentAssigneeName}
        </span>
        . Making it private will reassign it to you and hide it from the
        team.
      </div>
    </Modal>
  );
}
